import React from 'react';
import cx from 'classnames';
import {
  SkeletonProfileImage,
  SkeletonImage,
  SkeletonBody,
  SkeletonButton,
} from '@xingternal/skeleton';

import styles from './Skeleton.css';

const SkeletonLastItemLoggedout: React.FC = () => (
  <div className={cx(styles.skeletonWrapperLastItem, styles.skeletonWrapper)}>
    <SkeletonBody
      amountRows={2}
      className={styles.skeletonProfileInfoLastItem}
    />
    <SkeletonButton className={styles.skeletonButton} />
  </div>
);

const CompanyCardSkeletonLoggedout: React.FC = () => (
  <div className={cx(styles.skeletonWrapperLoggedout, styles.skeletonWrapper)}>
    <div>
      <div className={styles.relative}>
        <SkeletonImage
          size="medium"
          height="100px"
          className={styles.skeletonImage}
        />
        <div className={styles.absolute}>
          <SkeletonProfileImage size="small" />
        </div>
      </div>
      <div className={styles.skeletonProfileInfo}>
        <SkeletonBody amountRows={2} />
      </div>
    </div>
  </div>
);

const SkeletonIndustriesLoggedout: React.FC = () => (
  <div className={styles.skeletonWrapperIndustries}>
    <div className={styles.skeletonProfileInfo}>
      <SkeletonBody amountRows={2} size="small" />
    </div>
  </div>
);
const SkeletonIndustriesLoggedoutLastItem: React.FC = () => (
  <div className={styles.skeletonWrapperIndustries}>
    <SkeletonButton className={styles.skeletonButton} />
  </div>
);

export const SkeletonLoggedOutIndustriesPage: React.FC = () => (
  <div
    data-testid="skeleton-industries-page"
    className={cx(styles.skeletonRowIndustries, styles.skeletonRow)}
  >
    <div className={styles.wrapperRow}>
      <SkeletonIndustriesLoggedout />
      <SkeletonIndustriesLoggedout />
      <SkeletonIndustriesLoggedout />
      <SkeletonIndustriesLoggedout />
    </div>
    <div className={styles.wrapperRow}>
      <SkeletonIndustriesLoggedout />
      <SkeletonIndustriesLoggedout />
      <SkeletonIndustriesLoggedout />
      <SkeletonIndustriesLoggedout />
    </div>
  </div>
);

export const SkeletonLoggedOutIndustriesRow = () => (
  <div
    data-testid="skeleton-industries-module"
    className={cx(styles.skeletonRowIndustries, styles.skeletonRow)}
  >
    <SkeletonBody
      className={styles.skeletonHeader}
      amountRows={2}
      size="small"
      sizeWide="small"
    />
    <div className={styles.wrapperRow}>
      <SkeletonIndustriesLoggedout />
      <SkeletonIndustriesLoggedout />
      <SkeletonIndustriesLoggedout />
      <SkeletonIndustriesLoggedout />
      <SkeletonIndustriesLoggedoutLastItem />
    </div>
  </div>
);

export const CompanyCardsSkeletonLoggedoutPage: React.FC = () => (
  <div data-testid="skeleton-loggedout-page" className={styles.skeletonRow}>
    <div className={styles.wrapperRow}>
      <CompanyCardSkeletonLoggedout />
      <CompanyCardSkeletonLoggedout />
      <CompanyCardSkeletonLoggedout />
      <CompanyCardSkeletonLoggedout />
      <CompanyCardSkeletonLoggedout />
    </div>
  </div>
);

export const CompanyCardsSkeletonLoggedout = () => (
  <div data-testid="skeleton-loggedout-body" className={styles.skeletonRow}>
    <SkeletonBody className={styles.skeletonHeader} amountRows={2} />
    <div className={styles.wrapperRow}>
      <CompanyCardSkeletonLoggedout />
      <CompanyCardSkeletonLoggedout />
      <CompanyCardSkeletonLoggedout />
      <CompanyCardSkeletonLoggedout />
      <SkeletonLastItemLoggedout />
    </div>
  </div>
);
